module.exports = __webpack_public_path__ + "static/media/s_golf.7aaa6557.mp3";